/**
 * Default method used to compare if a row has changed and hence should
 * rerender
 */
function shallowCompare(a, b) {
  for (const key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }
  return true;
}

export { shallowCompare };
//# sourceMappingURL=shallowCompare.js.map
